export class LinearSliderScale {
  constructor(start, end, isDateType) {
    this._start = start;
    this._end = end;
    this._length = end - start;
    this._isDateType = isDateType;
  }
  position(value) {
    // TODO: probably move this to an internal adapter so everyone doesn't have
    //     | to implement this check.
    if (this._start === this._end) {
      return 0;
    }
    return (value - this._start) / this._length;
  }
  value(position) {
    const result = position * this._length + this._start;
    return this._isDateType ? Math.round(result) : result;
  }
  get minValue() {
    return this._start;
  }
  get maxValue() {
    return this._end;
  }
  static createFromLength(start, length, isDateType) {
    return new LinearSliderScale(start, start + length, isDateType);
  }
  static createFromMinMax(start, end, isDateType) {
    return new LinearSliderScale(start, end, isDateType);
  }
}
//# sourceMappingURL=SliderScale.js.map